import { connect } from 'react-redux';
import {
  downloadPayrollFBData,
  getDownloadPayrollFBDataErrors,
  clearDownloadPayrollFBDataErrors,
  clearFBDataService
} from 'src/reducers/employees/employeePays';
import { FORM_NAME_PAYS_SEARCH, takePaymentRangeFormSearchForm } from 'src/reducers/searchForm';
import { getSelectOptions } from 'src/reducers/selectOptions';
import { BANK_SELECTS } from 'src/constants/Options';
import FbDataModal from '../components/PayrollFBDataModal';

const mapStateToProps = state => {
  const paymentRange = takePaymentRangeFormSearchForm(state, FORM_NAME_PAYS_SEARCH);
  const uniquePaymentDates = getSelectOptions(state, 'uniquePaymentDates');
  const currentOption = uniquePaymentDates.find(opt => opt.value === paymentRange.yearMonth);
  const fbDataBankCodes = (currentOption && currentOption.bankCodes) || [];
  const fbDataBankOptions = BANK_SELECTS.filter(b => fbDataBankCodes.includes(b.value));
  return {
    paymentRange,
    errors: getDownloadPayrollFBDataErrors(state),
    fbDataBankOptions
  };
};

const mapDispatchToProps = dispatch => ({
  clearFBDataService: () => dispatch(clearFBDataService()),
  onModalHide: () => dispatch(clearDownloadPayrollFBDataErrors()),
  handleSubmit: (data, paymentRange) => {
    dispatch(downloadPayrollFBData({ ...data, ...paymentRange }));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(FbDataModal);
